// src/App.js
import React, { useState, useEffect } from "react";
import Header from "./Header";
import Navigation from "./Navigation";
import About from "./About";
import Skills from "./Skills";
import Experience from "./Experience";
import Projects from "./Projects";
import BusinessCard from "./BusinessCard";
import Footer from "./Footer";
import ProjectModal from "./ProjectModal";
import { ModalProvider } from "../context/ModalContext";
import BOLT from "./BOLT";

const Portfolio = () => {
	const [activeSection, setActiveSection] = useState("about");
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			setScrolled(window.scrollY > 10);
		};

		window.addEventListener("scroll", handleScroll);
		return () => window.removeEventListener("scroll", handleScroll);
	}, []);

	// Handle hash changes to switch sections
	useEffect(() => {
		const handleHashChange = () => {
			const hash = window.location.hash.replace("#", "");
			if (
				hash &&
				[
					"about",
					"skills",
					"experience",
					"projects",
					"businesscard",
				].includes(hash)
			) {
				setActiveSection(hash);
			}
		};

		// Check hash on initial load
		handleHashChange();

		// Listen for hash changes
		window.addEventListener("hashchange", handleHashChange);
		return () => window.removeEventListener("hashchange", handleHashChange);
	}, []);

	const sectionComponents = {
		about: About,
		skills: Skills,
		experience: Experience,
		bolt: BOLT,
		projects: Projects,
		businesscard: BusinessCard,
	};
	const ActiveSection = sectionComponents[activeSection] || About;

	return (
		<ModalProvider>
			<div className="min-h-screen bg-slate-50 text-slate-800 font-sans antialiased">
				{/* Header */}
				<Header />

				{/* Navigation */}
				<Navigation
					activeSection={activeSection}
					setActiveSection={setActiveSection}
					scrolled={scrolled}
				/>

				{/* Main Content */}
				<main
					id="main-content"
					className="container mx-auto px-6 py-12 md:py-16"
				>
					{/* Keyed so each section switch replays its entrance animation */}
					<div
						key={activeSection}
						id={activeSection}
						className="animate-fade-up"
					>
						<ActiveSection />
					</div>
				</main>

				{/* Project Modal */}
				<ProjectModal />

				{/* Footer */}
				<Footer />
			</div>
		</ModalProvider>
	);
};

export default Portfolio;
